<div class="row margin-0">
  <div class="col-md-12 padding-left-0 padding-right-0 margin-bottom-5 landing-nav-sticky">
    <div class="hpanel gs-cardgs-card">
      <div class="mainNav panel-body border-radius-top-left-right-6">
        <div class="navIteam">
          <h6>{{letterCaps(btnnameshow)}} :
            <span> {{count}}</span>
          </h6>
        </div>

        <div class="navIteam pos-rel-10">
              <input #txt (input)="keyupdata(txt.value)" type="text"[disabled]="isSearchDisabled()"  class="form-control input-sm pd-lt-10 search-field-pad"
                placeholder="Search Workspace" aria-label="Amount (to the nearest dollar)" [(ngModel)]="searchContent"
                name="searchadmin" id="searchadmin" />
          <ng-icon name="tablerSearch" class="pos-rel-25"></ng-icon>
        </div>
        <div class="navIteam connectionbtn">
          <button class="btn btn-primary displayflex" *ngIf="userType != 'JOB_SEEKER' && membershipType != 'Free'"
            (click)="openModalWithComponent()">
            <span class="mr-5"> </span> Create Workspace
          </button>
        </div>
        <div
          *ngIf="membershipType=='Growth' || membershipType=='Starter' || membershipType=='ScaleX'"
          class="navIteam">

          <div
            class="btn-group"
            dropdown
            container="body"
            placement="bottom right">

            <!-- Single Filter Button -->
            <button
              type="button"
              class="btn btn-primary filter-single-btn"
              dropdownToggle
              data-toggle="dropdown">

              <span>{{ letterCaps(btnnameshow) }}</span>
              <ng-icon name="tablerFilter"></ng-icon>

            </button>

            <!-- Dropdown -->
            <ul class="dropdown-menu no-padding dropmenu" *dropdownMenu role="menu">

              <li role="menuitem" (click)="filterteam('ALL')">
                <a class="dropdown-item" [class.selected]="activeFilter === 'ALL'">All</a>
              </li>

              <li role="menuitem" (click)="filterteam('ACTIVE')">
                <a class="dropdown-item" [class.selected]="activeFilter === 'ACTIVE'">Active Workspaces</a>
              </li>

              <li role="menuitem" (click)="filterteam('DEACTIVATED')">
                <a class="dropdown-item" [class.selected]="activeFilter === 'DEACTIVATED'">Deactive Workspaces</a>
              </li>

              <li role="menuitem" (click)="filterteam('INACTIVE')">
                <a class="dropdown-item" [class.selected]="activeFilter === 'INACTIVE'">Inactive Workspaces</a>
              </li>

              <li role="menuitem" (click)="filterteam('PENDING')">
                <a class="dropdown-item" [class.selected]="activeFilter === 'PENDING'">Requests Received</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </div>
  </div>
 
  <div *ngIf="membershipType=='Growth'||membershipType=='Starter'||membershipType=='ScaleX'||userType=='JOB_SEEKER'"
    class="col-sm-75 col-md-75 col-lg-75 padding-left-0 padding-right-0">

    <ng-container *ngIf="(connectionlistuserdata | async)?.length == 0 && loadAPIcall">
      <div class="col-md-6 col-lg-3 padding-left-0 padding-right-5" style="margin-bottom: 5px;"
        *ngFor="let n of [1, 2, 3, 4, 5, 6, 7, 8]">
        <app-common-skeleton [NameOftheScreen]="'teamcard'"></app-common-skeleton>
      </div>
    </ng-container>
    <ng-container *ngIf="(connectionlistuserdata | async)?.length>0">
      <div class="col-md-6 col-lg-3 padding-left-0 padding-right-5" infiniteScroll [infiniteScrollDistance]="4"
        [scrollWindow]="true" [infiniteScrollThrottle]="1000" (scrolled)="onScrollDown()"
        *ngFor="let data of  (connectionlistuserdata | async) | customFilter:{teamName:searchKey}:false">
        <app-teamcard (onSubmit)="onSubmit($event)" [userDataInput]="data"></app-teamcard>
      </div>
    </ng-container>
    <ng-container *ngIf="showNoDatafound">
      <!-- <app-nodata-found [buttonShow]="showButton" [isButtonDisabled]="popupvisible" [title]="noDatafound"
        [buttonName]="'Create Workspace'" (clickButton)="openModalWithComponent()"></app-nodata-found> -->

        
    <app-nodata-found [buttonShow]="showButton" [isButtonDisabled]="popupvisible" [title]="noDatafound"
    [buttonName]="'Create Workspace'" (clickButton)="openModalWithComponent()"
     *ngIf=" btnnameshow === 'All' && membershipType != 'Free'" [screen]="'TEAM'"></app-nodata-found>
    <app-nodata-found [title]="noDatafound" *ngIf=" btnnameshow !== 'All'"></app-nodata-found>

    </ng-container>
    <ng-container *ngIf="(connectionlistuserdata | async)?.length > 0 && loadAPIcall">
      <div class="col-md-6 col-lg-3 padding-left-0 padding-right-5" style="margin-bottom: 5px;" *ngFor="let n of [1, 2, 3, 4]">
        <app-common-skeleton [NameOftheScreen]="'teamcard'"></app-common-skeleton>
      </div>
    </ng-container>
    <div *ngIf="showWorkExpereince">
      <app-workexperience-modal [header]="'Current Organization Details'" (ModalEmitter)="showTeamIfWorkExpSucess($event)"
        [content]="'TEAM'" [ButtonName]="'Submit'" [supportModal]="supportModal"></app-workexperience-modal>
    </div>
  </div>



  <div *ngIf="membershipType=='Free'||membershipType=='Pro'"
    class="col-sm-75 col-md-75 col-lg-75 padding-left-0 padding-right-0">
    <app-upgrade-message [Page]="page">
    </app-upgrade-message>
  </div>

  <div class="col-sm-25 col-md-25 col-lg-25  padding-left-0 padding-right-0 landing-sticky-widget">
    <div class="">
      <app-common-widget [page]="'TEAMS_PAGE'" [inputData]="'TEAM'" [userType]="'ALL'"></app-common-widget>
    </div>
  </div>

  <div class="col-sm-8 gs-end-of-list" *ngIf="stopScroll && (connectionlistuserdata | async)?.length > 0" style="text-align: center; padding-top: 1rem;">
    <div class="col-sm-12">
      <!-- <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon> -->
      <ng-icon name="tablerCircleCheck"></ng-icon>

    </div>
    <div class="col-sm-12">
      <p class="biase">You've reached the bottom of the page</p>
    </div>
  </div>
</div>


<app-message-widget *ngIf="messagemodelflag" (closeMessageModel)="closeMessage()" style="z-index: -1;"
  [messageDataPass]="messageData"> </app-message-widget>
